import { Controller } from '@hotwired/stimulus'
import { loadMiniFastModal, openMiniFastModal } from '@/utils/mini_fast'

export default class extends Controller {
  static values = {
    invitedProvider: Object
  }

  connect() {
    this.clickHandler = event => this.click(event)
    this.element.addEventListener('click', this.clickHandler)

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.preloadHandler = () => this.preload()
      this.element.addEventListener('mouseenter', this.preloadHandler)
      this.element.addEventListener('mousedown', this.preloadHandler)
    } else {
      this.touchPreloadHandler = () => this.preload()
      this.element.addEventListener('touchstart', this.touchPreloadHandler, { passive: true })
    }
  }

  disconnect() {
    this.element.removeEventListener('click', this.clickHandler)
    if (this.preloadHandler) {
      this.element.removeEventListener('mouseenter', this.preloadHandler)
      this.element.removeEventListener('mousedown', this.preloadHandler)
    }
    if (this.touchPreloadHandler) {
      this.element.removeEventListener('touchstart', this.touchPreloadHandler)
    }
  }

  async preload() {
    if (this.preloading) {
      while (this.preloading) {
        await new Promise(resolve => setTimeout(resolve, 50))
      }
      return
    }

    this.preloading = true
    if (this.fastType === 'mini') {
      await loadMiniFastModal()
    } else {
      if (!window.FastApp) {
        const { fastApp } = await import('@/apps/fast/main.js')
        await fastApp
      }
    }
    this.preloading = false
  }

  async click(event) {
    event.preventDefault()
    await this.preload()

    const el = this.element
    const title = el.getAttribute('data-fast-project-title')
    const href = el.getAttribute('href')

    if (this.fastType === 'mini') {
      openMiniFastModal({
        invitedProvider: this.invitedProviderValue,
        prefilledProjectTitle: title
      })
    } else {
      window.FastApp.launch(href, {
        invitedProvider: this.invitedProviderValue,
        prefilledProjectTitle: title
      })
    }
  }

  get fastType() {
    return document.querySelector('meta[name="fast"]')?.content || 'default'
  }
}
